import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '@app/core/services/employee.service';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { CultureService } from '@app/core/services/system-language/culture.service';
import { TimezoneService } from '@app/core/services/timezone/timezone.service';
import { Organization } from '@app/modules/organization-structure/models/organization-structure.model';
import { OrganizationStructureService } from '@app/modules/organization-structure/services/organization-structure.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { Timezone } from '@app/shared/models/timezone.model';
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-dummy-employees',
  templateUrl: './add-dummy-employees.component.html',
  styleUrls: ['./add-dummy-employees.component.scss']
})
export class AddDummyEmployeesComponent implements OnInit {
  loadingTypes: boolean = true;
  loadingOrgs: boolean = true;
  orgs: Organization[];
  numberOfItems: number = 20;
  organizationTypes: Organization[];
  cultures: Culture[];
  timezones: Timezone[];

  constructor(
    private snackbarService: SnackbarService,
    private overlayService: OverlayService,
    private organizationService: OrganizationStructureService,
    private cultureService: CultureService,
    private timezoneService: TimezoneService,
    private employeeService: EmployeeService,
  ) { }

  ngOnInit(): void {
    this.getAllOrganizations();
    this.getCultures();
    this.getTimezones();
  }

  createRandomString(length: number): string {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length);
  }

  getAllOrganizations() {
    this.loadingOrgs = true;

    this.organizationService.getOrganizations(100, 0)
    .pipe(
      finalize( () => {
        this.loadingOrgs = false;
      })
    )
    .subscribe(
      res => {
        this.orgs = res.data;
      }
    )
  }

  getCultures() {
    this.cultureService.getCultures()
    .subscribe(
      res => {
        this.cultures = res;
      }
    )
  }

  getTimezones() {
    this.timezoneService.getTimezones()
    .subscribe(
      res => {
        this.timezones = res.data;
      }
    )
  }

  random_item(items){
    return items[Math.floor(Math.random()*items.length)];
  }

  getNewEmployee(): any {
    return {
      firstname: `Dummy-${this.createRandomString(10)}`,
      lastname: `Dummy-${this.createRandomString(10)}`,
      organization: this.random_item(this.orgs).id,
      timezone: this.random_item(this.timezones).id,
      culture: this.random_item(this.cultures).id,
      username: `Dummy${this.createRandomString(10)}@${this.createRandomString(10)}.com`,
    };
  }

  createItems() {
    let createItemRequests: Observable<any>[] = [];

    for (let i = 0; i < this.numberOfItems; i++) {
      createItemRequests.push(this.employeeService.createTalent(this.getNewEmployee()))
    }

    this.overlayService.show();
    forkJoin(createItemRequests)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
        (res) => {
            this.snackbarService.openSnackBar(`Created ${this.numberOfItems} Empoloyees(s) Successfully`, 'clear', 'success');
        }
    );
  }
}
